module.exports = wxcomp;


//////////////////
// WEBPACK FOOTER
// external "wxcomp"
// module id = 1
// module chunks = 22